import { render } from "./Outcome.vue?vue&type=template&id=7973d64d&scoped=true&ts=true"
import script from "./Outcome.vue?vue&type=script&lang=ts"
export * from "./Outcome.vue?vue&type=script&lang=ts"

import "./Outcome.vue?vue&type=style&index=0&id=7973d64d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7973d64d"]])

export default __exports__